import { dataHooks } from '@wix/data-hooks'

export const wixStudioSplitV2DataHooks = dataHooks<{
  title: {}
  option: { key: string }
  secondaryOption: { key: string }
  disclaimer: {}
}>('wix-studio-split-v2')
